module.exports = __webpack_public_path__ + "img/landing-invest-strategies.84351c5c.svg";